import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { ApiError } from './lib/api';
import { router } from './router';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // No 4xx heals by retrying (400/401/403/404/409/422/...) — those are
      // the caller's fault, not a transient failure, so hammering the same
      // request again just delays the same answer. Only network errors and
      // 5xx get the retry budget.
      retry: (failureCount, error) =>
        !(error instanceof ApiError && error.status >= 400 && error.status < 500) &&
        failureCount < 2,
    },
    // Explicit, not just relying on the library default: a mutation (the
    // "Підвищити рівень"/"Верифікувати"/etc. buttons) must never silently
    // fire twice on a 4xx — apiFetch already retries the one 4xx that CAN
    // heal itself (a stale CSRF token) internally, once, before this layer
    // ever sees an error.
    mutations: {
      retry: false,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('#root not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
